import {useHierarchyNavAccess} from '@domain/kpis'
import {Grid} from '@mui/material'
import {
  AreaDashboardContainer,
  AreaFilterContainer,
  type AreaRouteSegments,
  useMapMarkersData
} from '@widgets/area-dashboard'
import React from 'react'

import {SHIFT_QUICK_SELECT_SLOTS_OPTIMIZATION_SPECIALIST} from '../consts'
import {AreaOptimizationSpecialistCardContainer} from '../containers'

type Props = {
  title: string
  dashboardRoute: string
  routeSegments: AreaRouteSegments
  fallbackBreadcrumbs?: React.ReactNode
  useMapMarkersDataHook?: typeof useMapMarkersData
}

export const OptimizationSpecialistAreaDashboard = ({
  title,
  dashboardRoute,
  routeSegments,
  fallbackBreadcrumbs,
  useMapMarkersDataHook = useMapMarkersData
}: Props) => {
  const {allowedAreas, getAreaById} = useHierarchyNavAccess(
    'VIEW_OPTIMIZATION_SPECIALIST_DASHBOARD'
  )

  return (
    <AreaDashboardContainer
      dashboardTitle={title}
      dashboardRoute={dashboardRoute}
      routeSegments={routeSegments}
      permission="VIEW_OPTIMIZATION_SPECIALIST_DASHBOARD"
      useMapMarkersDataHook={useMapMarkersDataHook}
      useAccessHook={useHierarchyNavAccess}
      allowedAreas={allowedAreas}
      getAreaById={getAreaById}
      fallbackBreadcrumbs={fallbackBreadcrumbs}
      getPlantCards={(args: PlantCardsListProps) => (
        <PlantCardsList {...args} plantRouteSegment={routeSegments.plant} />
      )}
      headerActionContent={
        <AreaFilterContainer
          quickSelectSlots={SHIFT_QUICK_SELECT_SLOTS_OPTIMIZATION_SPECIALIST}
          defaultSlot="pastShift"
        />
      }
    />
  )
}

type PlantCardsListProps = {
  plantIds: string[]
  spacing?: number
  columnsCount?: number
  kpiGridItemXs?: number
}

const COLUMN_SIZE = 1

const PlantCardsList = ({
  plantIds,
  plantRouteSegment,
  spacing = 2,
  columnsCount = 1,
  kpiGridItemXs = 4
}: PlantCardsListProps & {plantRouteSegment: string}) => {
  return (
    <Grid container spacing={spacing} columns={columnsCount * COLUMN_SIZE}>
      {plantIds.map((plantId) => {
        return (
          <Grid key={plantId} item xs={COLUMN_SIZE}>
            <AreaOptimizationSpecialistCardContainer
              plantId={plantId}
              plantLink={`${plantRouteSegment}/${plantId}`}
              cardBoxSx={{width: '100%'}}
              kpiGridItemXs={kpiGridItemXs}
            />
          </Grid>
        )
      })}
    </Grid>
  )
}
